window.TICKET_HELP_FAQS = [
  {
    intents: ["vip", "premium", "worth it", "upgrade"],
    answer: (ctx) =>
      `VIP tickets include ${ctx.ticketTypes?.VIP || "premium access"} and are best if you want the full experience.`
  },
  {
    intents: ["ga", "general admission", "regular"],
    answer: (ctx) =>
      `General Admission includes ${ctx.ticketTypes?.GA || "event access"}.`
  },
  {
    intents: ["kids", "child", "children", "under 13", "age"],
    answer: () =>
      "Kids tickets are available for children 13 and under."
  },
  {
    intents: ["refund", "return", "cancel"],
    answer: (ctx) =>
      `Refunds are subject to our policy: ${ctx.refundPolicyUrl}`
  },
  {
    intents: ["where", "location", "address"],
    answer: (ctx) =>
      `The event takes place at ${ctx.location || "the listed venue on this page"}.`
  },
  {
    intents: ["multiple", "group", "friends", "family"],
    answer: () =>
      "Yes — you can purchase multiple tickets in a single checkout."
  }
];
